import React, { useEffect, useRef, useState } from "react";
import Topbar from "../components/Topbar";
import Leftbar from "../components/Leftbar";
import { Link } from "react-router-dom";
import {
  displayError,
  displaySuccess,
  getExtraPayments,
  cancelExtraPaymentRequest,
} from "../Utils/utils";
import { toggleLoader } from "../actions/loader";
import { connect } from "react-redux";
import ReactPaginate from "react-paginate";
import { Modal } from "react-bootstrap";
import moment from "moment";
import { getUserData } from "../actions/userdata";
import "../Gynac/style.css";
import "./bookings.css";

const statusClass = (status) => {
  const s = (status || '').toLowerCase();
  if (s === 'paid') return 'status-pill status-approved';
  if (s === 'cancelled') return 'status-pill status-rejected';
  return 'status-pill status-pending';
};

const sessionStatusClass = (status) => {
  const s = (status || '').toLowerCase();
  if (s === 'completed' || s === 'approved') return 'status-pill status-approved';
  if (s === 'cancelled' || s === 'rejected') return 'status-pill status-rejected';
  return 'status-pill status-pending';
};

const ExtraPayments = (props) => {
  const [groups, setGroups] = useState([]);
  const [count, setCount] = useState(10);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [totalGroups, setTotalGroups] = useState(0);
  const [detailTarget, setDetailTarget] = useState(null);
  const [cancelTarget, setCancelTarget] = useState(null);
  const [cancelling, setCancelling] = useState(false);
  const [search, setSearch] = useState('');
  const [statusFilter, setStatusFilter] = useState('all');

  const getList = async (perPage = count, pageNum = 1, searchQuery = search, status = statusFilter) => {
    props.toggleLoader(true);
    const res = await getExtraPayments(perPage, pageNum, searchQuery, status);
    setTotal(res?.metadata?.totalPage);
    setTotalGroups(res?.metadata?.totalCount);
    setPage(res?.metadata?.page);
    setGroups(res?.data || []);
    props.toggleLoader(false);
  };

  const isFirstRun = useRef(true);
  useEffect(() => {
    if (isFirstRun.current) {
      isFirstRun.current = false;
      getList(count, 1, search, statusFilter);
      return;
    }
    const handler = setTimeout(() => {
      getList(count, 1, search, statusFilter);
    }, 400);
    return () => clearTimeout(handler);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search, statusFilter]);

  const handlePageClick = async (e) => {
    const selectedPage = e.selected + 1;
    window.scroll({ top: 0, left: 0, behavior: "smooth" });
    getList(count, selectedPage);
  };

  const handlePerPageChange = (e) => {
    const next = parseInt(e.target.value, 10);
    setCount(next);
    getList(next, 1);
  };


  const openCancelModal = (group) => {
    const pendingRequest = (group?.requests || []).find((r) => r?.status === 'pending');
    if (!pendingRequest) return;
    setCancelTarget({
      requestId: pendingRequest._id,
      amount: pendingRequest.amount,
      booking_number: group.booking_number,
      service_name: group.service_name,
    });
  };

  const handleCancelRequest = async () => {
    if (!cancelTarget?.requestId) return;
    setCancelling(true);
    props.toggleLoader(true);
    try {
      await cancelExtraPaymentRequest(cancelTarget.requestId);
      displaySuccess('payment request cancelled');
      setCancelTarget(null);
      await getList(count, page);
    } catch (err) {
      displayError(err);
    } finally {
      setCancelling(false);
      props.toggleLoader(false);
    }
  };

  return (
    <div className="g-sidenav-show bg-gray-100">
      <div id="wrapper">
        <Leftbar />
        <main className="main-content border-radius-lg">
          <Topbar />

          <div className="header bg-primary pb-6">
            <div className="container-fluid">
              <div className="header-body">
                <div className="row align-items-center py-4">
                  <div className="col-lg-6 col-7">
                    <nav aria-label="breadcrumb" className="d-none d-md-inline-block ml-md-4">
                      <ol className="breadcrumb breadcrumb-links breadcrumb-dark">
                        <li className="breadcrumb-item"><Link to="/dashboard"><i className="fas fa-home" /></Link></li>
                        <li className="breadcrumb-item"><a href="#">Payment Requests</a></li>
                      </ol>
                    </nav>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="container-fluid mt--6"></div>
          <div className="container-fluid">
            <div className="card gynac-card">
              <div className="gynac-card-header">
                <h3 className="gynac-title">
                  Payment Requests
                  <span className="gynac-count-chip">
                    {totalGroups ? totalGroups : 0}{search || statusFilter !== 'all' ? ` of ${groups.length}` : ''}
                  </span>
                </h3>

                <div className="gynac-toolbar">
                  <div className="gynac-search">
                    <i className="fas fa-search search-icon" />
                    <input
                      type="text"
                      placeholder="Search booking, customer"
                      value={search}
                      onChange={(e) => setSearch(e.target.value)}
                    />
                  </div>
                  <div className="gynac-filter">
                    <select value={statusFilter} onChange={(e) => setStatusFilter(e.target.value)}>
                      <option value="all">All status</option>
                      <option value="pending">Pending</option>
                      <option value="paid">Paid</option>
                      <option value="cancelled">Cancelled</option>
                    </select>
                  </div>
                </div>
              </div>

              <div className="table-responsive">
                <table className="gynac-table bookings-table">
                  <colgroup>
                    <col style={{ width: '18%' }} />
                    <col style={{ width: '22%' }} />
                    <col style={{ width: '14%' }} />
                    <col style={{ width: '16%' }} />
                    <col style={{ width: '12%' }} />
                    <col style={{ width: '18%' }} />
                  </colgroup>
                  <thead>
                    <tr>
                      <th>Booking</th>
                      <th>Customer</th>
                      <th style={{ textAlign: 'center' }}>Requests</th>
                      <th style={{ textAlign: 'right' }}>Amount</th>
                      <th>Status</th>
                      <th style={{ textAlign: 'center' }}>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {groups.map((group) => (
                      <tr key={group?.booking_id}>
                        <td data-label="Booking">
                          {group?.booking_number ? (
                            <div className="booking-no">#{group.booking_number}</div>
                          ) : (
                            <div className="booking-no">{group?.service_name || '—'}</div>
                          )}
                          {group?.booking_number && group?.service_name && (
                            <div className="booking-meta">
                              <span className="meta-value">{group.service_name}</span>
                            </div>
                          )}
                          {group?.provider?.name && (
                            <div className="booking-meta">
                              <span className="meta-label">To</span>
                              <span className="meta-value">{group.provider.name}</span>
                            </div>
                          )}
                          {group?.assigned_by?.name && (
                            <div className="booking-meta">
                              <span className="meta-label">By</span>
                              <span className="meta-value">{group.assigned_by.name}</span>
                            </div>
                          )}
                          {group?.session?.date && (
                            <div className="schedule-date" style={{ marginTop: 4,fontSize : 12,fontWeight : '500', display: 'flex', alignItems: 'center', gap: 6, flexWrap: 'wrap' }}>
                              Session Time : &nbsp;  
                               {moment(group.session.date).format('DD MMM YYYY')}
                              {group.session.fromTime && group.session.toTime
                                ? `,  ${group.session.fromTime}–${group.session.toTime}`
                                : ''}
                              {/* {group.session.status && (
                                <span className={sessionStatusClass(group.session.status)} style={{ textTransform: 'capitalize' }}>
                                  {group.session.status}
                                </span>
                              )} */}
                            </div>
                          )}
                          <div className="schedule-date" style={{ marginTop: 2 }}>
                            Last request : {moment(group?.last_requested_at).format('DD MMM YYYY, HH:mm')}
                          </div>
                        </td>

                        <td data-label="Customer">
                          <div className="customer-name">{group?.user?.name || '—'}</div>
                          <div className="customer-contact">
                            {group?.user?.phone_number && (
                              <div className="customer-contact-row">
                                <i className="fas fa-phone fa-flip-horizontal" />
                                <span>{group.user.phone_number}</span>
                              </div>
                            )}
                            {group?.user?.email && (
                              <div className="customer-contact-row">
                                <i className="fas fa-envelope" />
                                <a href={`mailto:${group.user.email}`} title={group.user.email}>{group.user.email}</a>
                              </div>
                            )}
                          </div>
                        </td>

                        <td data-label="Requests" style={{ textAlign: 'center' }}>
                          <span className="gynac-count-chip">{group?.total_requests ?? 0}</span>
                        </td>

                        <td data-label="Amount" style={{ textAlign: 'right' }}>
                          {group?.total_paid_amount > 0 ? (
                            <div style={{ color: '#0ca678', fontWeight: 700 }}>
                            Paid ₹{Number(group.total_paid_amount).toLocaleString('en-IN')}
                            </div>
                          ) :  <div style={{ color: '#000', fontWeight: 500 }}>
                            {group?.total_pending_amount > 0 ? '' : 0}</div> }
                          {group?.total_pending_amount > 0 && (
                            <div style={{ color: '#b8771f', fontWeight: 700 }}>
                              Pending ₹{Number(group.total_pending_amount).toLocaleString('en-IN')}
                            </div>
                          )}
                        </td>

                        <td data-label="Status">
                          <span className={statusClass(group?.latest_status)} style={{ textTransform: 'capitalize' }}>
                            {group?.latest_status}
                          </span>
                        </td>

                        <td data-label="Actions" style={{ textAlign: 'center' }}>
                          <div className="booking-actions">
                            <button
                              className="booking-action-btn ba-view"
                              onClick={() => setDetailTarget(group)}
                            >
                              View Details
                            </button>
                            {group?.latest_status === 'pending' && (
                              <button
                                className="booking-action-btn ba-cancel-payment"
                                onClick={() => openCancelModal(group)}
                              >
                                Cancel Request
                              </button>
                            )}
                          </div>
                        </td>
                      </tr>
                    ))}

                    {!groups.length && (
                      <tr>
                        <td colSpan={6}>
                          <div className="gynac-empty">
                            <i className="fas fa-money-bill-wave" />
                            <div className="gynac-empty-text">No payment requests found</div>
                          </div>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>

              {groups.length > 0 && (
                <div className="gynac-footer">
                  <div className="gynac-per-page">
                    <span>Rows per page</span>
                    <select value={count} onChange={handlePerPageChange}>
                      <option value={10}>10</option>
                      <option value={25}>25</option>
                      <option value={50}>50</option>
                    </select>
                  </div>
                  <div className="paginate-css" style={{ margin: 0 }}>
                    <ReactPaginate
                      previousLabel="<"
                      nextLabel=">"
                      breakLabel="..."
                      pageCount={total}
                      forcePage={page > 0 ? page - 1 : 0}
                      marginPagesDisplayed={1}
                      pageRangeDisplayed={3}
                      onPageChange={handlePageClick}
                      containerClassName="pagination"
                      activeClassName="active"
                    />
                  </div>
                </div>
              )}
            </div>
          </div>

          {/* Booking extra-payment history modal */}
          <Modal show={!!detailTarget} onHide={() => setDetailTarget(null)} centered size="lg">
            <Modal.Header style={{ borderBottom: '1px solid #e9ecef' }}>
              <div>
                <h5 className="mb-0" style={{ fontWeight: 700 }}>
                  Payment Requests History
                  {detailTarget?.booking_number
                    ? ` — Booking #${detailTarget.booking_number}`
                    : detailTarget?.service_name
                      ? ` — ${detailTarget.service_name}`
                      : ''}
                </h5>
                {detailTarget?.user?.name && (
                  <div style={{ fontSize: '0.85rem', color: '#6b7088', marginTop: 4 }}>
                    {detailTarget.user.name}
                    {detailTarget?.user?.phone_number ? ` · ${detailTarget.user.phone_number}` : ''}
                  </div>
                )}
              </div>
              <button type="button" style={{ background: 'none', border: 'none', fontSize: 22, cursor: 'pointer', lineHeight: 1 }} onClick={() => setDetailTarget(null)}>&times;</button>
            </Modal.Header>
            <Modal.Body style={{ padding: '20px 24px', maxHeight: '65vh', overflowY: 'auto' }}>
              {(detailTarget?.requests || []).map((req, idx) => (
                <div
                  key={req?._id || idx}
                  style={{
                    border: '1px solid #e9ecef',
                    borderRadius: 10,
                    padding: '14px 16px',
                    marginBottom: 12,
                  }}
                >
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 12 }}>
                    <div>
                      <div style={{ fontWeight: 700, color: '#1f2540', marginBottom: 4 }}>
                        ₹{Number(req?.amount ?? 0).toLocaleString('en-IN')}
                      </div>
                      <div style={{ fontSize: '0.9rem', color: '#333' }}>{req?.reason || '—'}</div>
                    </div>
                    <span className={statusClass(req?.status)} style={{ textTransform: 'capitalize', flexShrink: 0 }}>
                      {req?.status}
                    </span>
                  </div>
                  <div style={{ marginTop: 10, fontSize: '0.78rem', color: '#8898aa', display: 'flex', flexWrap: 'wrap', gap: '4px 16px' }}>
                    <span>Requested : {moment(req?.createdAt).format('DD MMM YYYY, HH:mm')}</span>
                    {req?.created_by_admin?.name && (
                      <span>Requested by : {req.created_by_admin.name}</span>
                    )}
                    {req?.status === 'paid' && req?.paid_at && (
                      <span>Paid : {moment(req.paid_at).format('DD MMM YYYY, HH:mm')}</span>
                    )}
                    {req?.status === 'cancelled' && req?.cancelled_at && (
                      <span>Cancelled : {moment(req.cancelled_at).format('DD MMM YYYY, HH:mm')}</span>
                    )}
                    {req?.status === 'cancelled' && req?.cancelled_by_admin?.name && (
                      <span>Cancelled by : {req.cancelled_by_admin.name}</span>
                    )}
                    {/* {req?.cashfree_order_id && (
                      <span>Order: {req.cashfree_order_id}</span>
                    )}
                    {req?.cashfree_payment_id && (
                      <span>Payment ID: {req.cashfree_payment_id}</span>
                    )} */}
                  </div>
                </div>
              ))}
              {!(detailTarget?.requests || []).length && (
                <div className="gynac-empty">
                  <div className="gynac-empty-text">No requests found</div>
                </div>
              )}
            </Modal.Body>
          </Modal>

          {/* Cancel extra payment request confirm modal */}
          <Modal
            show={!!cancelTarget}
            onHide={() => !cancelling && setCancelTarget(null)}
            centered
            backdrop="static"
          >
            <Modal.Header style={{ borderBottom: '1px solid #e9ecef' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                <span style={{ width: 40, height: 40, borderRadius: '50%', background: '#fdebec', color: '#c22627', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', fontSize: 18 }}>
                  <i className="fas fa-exclamation-triangle" />
                </span>
                <h5 className="mb-0" style={{ fontWeight: 700 }}>Cancel payment request?</h5>
              </div>
              <button type="button" style={{ background: 'none', border: 'none', fontSize: 22, cursor: 'pointer', lineHeight: 1 }} onClick={() => !cancelling && setCancelTarget(null)} disabled={cancelling}>&times;</button>
            </Modal.Header>
            <Modal.Body style={{ padding: '20px 24px', fontSize: '0.95rem', color: '#333' }}>
              Are you sure you want to cancel the payment request of{' '}
              <strong style={{ color: '#1f2540' }}>₹{Number(cancelTarget?.amount ?? 0).toLocaleString('en-IN')}</strong>
              {' '}for booking{' '}
              <strong style={{ color: '#1f2540' }}>
                {cancelTarget?.booking_number ? `#${cancelTarget.booking_number}` : (cancelTarget?.service_name || '')}
              </strong>?
            </Modal.Body>
            <Modal.Footer style={{ borderTop: '1px solid #e9ecef' }}>
              <button
                className="btn"
                style={{ background: '#fff', border: '1px solid #d0d4e0', color: '#6b7088', borderRadius: 999, fontWeight: 600, padding: '6px 18px' }}
                onClick={() => setCancelTarget(null)}
                disabled={cancelling}
              >
                Keep it
              </button>
              <button
                className="btn"
                style={{ background: '#c22627', color: '#fff', border: '1px solid #c22627', borderRadius: 999, fontWeight: 600, padding: '6px 18px', opacity: cancelling ? 0.7 : 1, cursor: cancelling ? 'not-allowed' : 'pointer' }}
                onClick={handleCancelRequest}
                disabled={cancelling}
              >
                {cancelling ? 'Cancelling…' : 'Cancel Request'}
              </button>
            </Modal.Footer>
          </Modal>
        </main>
      </div>
    </div>
  );
};

const mapDispatchToProps = { toggleLoader, getUserData };
const mapStateToProps = (state) => ({ userdata: state.userdata?.userData });
export default connect(mapStateToProps, mapDispatchToProps)(ExtraPayments);
